import { define } from '../../define.js';
import { Popover } from './popover.js';
export * from './popover.js';
define('popover', Popover);
